"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./modal.module"), exports);
tslib_1.__exportStar(require("./modal.service"), exports);
//# sourceMappingURL=index.js.map